import styled from '@emotion/styled';

import { Image as _Image } from '@hrworks/sui-core/Image';

const Image = styled(_Image)(({ theme }) => ({
  borderRadius: theme.eclipseTier1.radius['12px'],
  width: 100,
  height: 100,
  maxWidth: '100%',
  maxHeight: '100%',
}));

const Content = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.eclipseTier1.spacing['12px'],
}));

export const S = {
  Image,
  Content,
} as const;
